import {apiClient} from "@/service/ApiClient";

export interface GameData {
    id: number
    teamId: number
    matchDt: string
    time: string
    place: string
    type: string
    playersCountType: string
    teamAScore?: number
    teamBScore?: number
    status: string
    writerId: number
    writerName?: string
    vsName?: string
}

export interface GameItem {
    id?: number | undefined
    teamId?: number | undefined
    matchDt: string
    time: string
    place: string
    type: string
    playersCountType: string
    vsName?: string
    status?: string
    teamAScore?: string | number
    teamBScore?: string | number
}

const getGameList = async () =>
    apiClient.get<GameData[]>("/game/list").then(res => res.data)

const postGame = async (game: GameItem | undefined) =>
    apiClient.post<GameData>("/game", {...game}).then(res => res.data)

const putGame = async (game: GameItem, gameId: number) =>
    apiClient.patch("/game/" + gameId.toString(), {...game})

const putGameResult = async (game: GameItem, gameId: number) =>
    apiClient.patch("/game/" + gameId.toString() + "/result", {...game})

/** 경기 단건 조회 */
const getGame = async (gameId: number) =>
    apiClient.get<GameItem>(`/game/${gameId}`).then(res => res.data)



const GameService = {
    getGameList,
    postGame,
    putGame,
    getGame,
    putGameResult
}

export default GameService
